const state = {
  bLeftCollapse: false,
  bRightCollapse: false,
  bFullScreen: false,
  userData: {},
  token: localStorage.getItem('userToken') || ''
}
const mutations = {
  bLeftCollapse_Mutation (state, data) {
    state.bLeftCollapse = data
  },
  bRightCollapse_Mutation (state, data) {
    state.bRightCollapse = data
  },
  bFullScreen_Mutation (state, data) {
    state.bFullScreen = data
  },
  userToken_Mutation (state, data) {
    state.token = data
  },
  userData_Mutation (state, data) {
    state.userData = data
  }
}
const actions = {
  bLeftCollapse_Action ({commit}, data) {
    commit('bLeftCollapse_Mutation', data)
  },
  bRightCollapse_Action ({commit}, data) {
    commit('bRightCollapse_Mutation', data)
  },
  bFullScreen_Action ({commit}, data) {
    commit('bFullScreen_Mutation', data)
  },
  userToken_Action ({commit}, data) {
    commit('userToken_Mutation', data)
  },
  userData_Action ({commit}, data) {
    commit('userData_Mutation', data)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/globalStore.js